import React, { useState, useMemo, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { darken, lighten } from "polished";
import Sidebar from "../../components/sideBar/sideBar.js";
import Navbar from "../../components/navbar/navbar.js";
import gridSideBar from "../../components/GridSideBar/gridSideBar.js";
import createColumnDefs from "./columnDefs.js";
import localStorage from "local-storage";
import SearchIcon from "@mui/icons-material/Search";

import {
  Grid,
  Typography,
  Pagination,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTr from "../../locale.tr.js";
import Swal from "sweetalert2";
import moment from "moment";
import { cleanupLocalStorage } from "../../utils/localStorage/cleanupLocalStorage.js";
import { createTurkishFilterParams } from "../../utils/agGridTextFilterTr/agGridFilterUtils.js";
import DateRangePicker from "../../components/DateRangePicker/index.js";
import { getTaxPayerListForWaitingDeclaration } from "../../api/taxPayer/getTaxPayerListForWaitingDeclaration/index.js";

function StatusWaitingPage() {
  const [rowData, setRowData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const today = moment().format("YYYY-MM-DD");
  const monthAgo = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(monthAgo);
  const [endDate, setEndDate] = useState(today);

  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(250);
  const [totalCount, setTotalCount] = useState(0);

  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    const lastPage = localStorage.get("page");
    const lastPageSize = localStorage.get("pageSize");
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    if (lastPage) {
      setCurrentPage(lastPage);
    }
    if (lastPageSize) {
      setPageSize(lastPageSize);
    }
    localStorage.get("scrollPosition");

    search();
    cleanupLocalStorage();
    window.addEventListener("beforeunload", cleanupLocalStorage);
    return () => {
      window.removeEventListener("beforeunload", cleanupLocalStorage);
    };
  }, []);

  useEffect(() => {
    const lastPage = localStorage.get("page");
    const lastPageSize = localStorage.get("pageSize");
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    if (lastPage) {
      setCurrentPage(lastPage);
    }
    if (lastPageSize) {
      setPageSize(lastPageSize);
    }
    localStorage.get("scrollPosition");
  }, [currentPage, pageSize]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // const onSelectionChanged = (event) => {
  //   const selectedNodes = event.api.getSelectedNodes();

  //   const selectedIds = selectedNodes.map((node) => node.data.id);
  //   // console.log(selectedIds, "selectedIds1");
  //   setSelectedIds(selectedIds);

  //   const selectedTaxPayersVknTckn = selectedNodes.flatMap((node) => {
  //     const values = [];
  //     if (node.data.vkn) values.push(node.data.vkn); // VKN her zaman eklenecek
  //     if (node.data.tckn) values.push(node.data.tckn); // TCKN boş değilse eklenecek
  //     return values;
  //   });

  //   // console.log(selectedTaxPayersVknTckn, "selectedTaxPayersVknTckn");
  //   setSelectedTaxPayersVknTckn(selectedTaxPayersVknTckn);
  //   const selectedTaxPayersTitle = selectedNodes.map((node) => node.data.title);
  //   setSelectedTaxPayersTitle(selectedTaxPayersTitle);
  //   //console.log(selectedTaxPayers,selectedIds);

  //   const selectedTaxPayersData = selectedIds.map((id, index) => ({
  //     id: id,
  //     name: selectedTaxPayersTitle[index],
  //   }));
  //   setSelectedTaxPayersData(selectedTaxPayersData);
  //   // console.log("Seçilen Mükellefler:", selectedTaxPayersData);
  // };

  const defaultColDef = useMemo(
    () => ({
      minWidth: 100,
      filter: true,
      sortable: true,
      resizable: true,
      floatingFilter: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );
  function clearLocalStorage() {
    localStorage.clear();
  }
  useEffect(() => {
    let timer;
    setTimeout(clearLocalStorage, 10 * 60 * 1000);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [pageSize, currentPage]);

  const search = () => {
    setLoading(true);

    getTaxPayerListForWaitingDeclaration(startDate, endDate)
      .then((resp) => {
        setRowData(resp.data.data);
        setTotalPage(resp.data.totalPage);
        setTotalCount(resp.data.totalCount);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          text:
            err.response.data.message || "Mükellefler alınırken hata oluştu.",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            container: ".swal-overlay",
          },
        });
      });
  };

  const [columnDefs, setColumnDefs] = useState(createColumnDefs(navigate));

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        defaultExpanded: false,
        // sideBar={gridSideBar},
        // enableRangeSelection: true,
        // paginationAutoPageSize: true,
        columnDefs: [{ field: "description" }],
        defaultColDef: {
          flex: 3,
          maxWidth: 300,
          resizable: true,
          floatingFilter: true,
          suppressMenu: false, // Allow menu in detail grid columns
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.subDetails);
      },
    };
  }, []);

  const onGridReady = useCallback(
    (params) => {
      setGridApi(params.api); // gridApi'yi burada ayarlayın
      setRowData(rowData); // mevcut satır verilerini ayarlayın
    },
    [rowData]
  );

  return (
    <Grid container>
      <Grid
        item
        sx={{
          flexBasis: isOpen ? "275px" : "95px",
          flexShrink: 0,
          transition: "flex-basis 0.3s ease", // Düzeltilmiş transition
        }}
      >
        <Sidebar status={isOpen} toggleSidebar={toggleSidebar} />
      </Grid>

      <Grid
        item
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          gap: 1,
          pr: "12px",
        }}
      >
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid item md={12} sx={{ display: "flex", flexDirection: "column" }}>
          <Grid
            className="grid-area"
            sx={{
              mb: 1,
            }}
          >
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
            <Button
              sx={{
                textTransform: "none",
                alignItems: "center",
                gap: 1,
                marginLeft: "1vw",

                backgroundColor: "#00cfe8",
                "&:hover": {
                  backgroundColor: darken(0.1, "#00cfe8"),
                  borderColor: "#d9534f",
                },
              }}
              variant="contained"
              type="submit"
              onClick={() => search()}
            >
              <SearchIcon color="white" />
              Ara
            </Button>
          </Grid>

          <Grid
            className="ag-theme-quartz"
            style={{
              flex: 1,
              minHeight: "70vh",
              maxHeight: "70vh",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: "10px", // İstediğiniz değeri buraya ekleyin
              overflow: "hidden", // Border-radius'in düzgün görünmesi için
            }}
          >
            <AgGridReact
              localeText={localeTextTr}
              rowSelection="multiple"
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              loading={loading}
              sideBar={gridSideBar}
              getRowStyle={(params) => {
                if (params.data.is_deleted === true) {
                  return { background: lighten(0.4, "red") };
                }
              }}
              copyHeadersToClipboard={false}
              defaultColDef={defaultColDef}
              masterDetail={true}
              detailCellRendererParams={detailCellRendererParams}
              suppressRowDeselection={true}
              enableRangeSelection={true}
              rowMultiSelectWithClick={true}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "space-between",
              display: rowData?.length === 0 ? "none" : "flex",

              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                display: rowData.length === 0 ? "none" : "flex",
                margin: "2% 0 2% 0",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Pagination
                count={totalPage}
                showFirstButton
                showLastButton
                page={currentPage}
                sx={{
                  display: loading ? "none" : "block",
                }}
                onChange={(event, value) => {
                  search(undefined, value, pageSize);
                  setCurrentPage(value);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  localStorage.set("page", value);
                }}
              />
              <TextField
                select
                value={pageSize}
                size="small"
                sx={{
                  display: rowData.length === 0 || loading ? "none" : "block",
                }}
                onChange={(e) => {
                  search(undefined, 1, e.target.value);
                  setCurrentPage(1);
                  localStorage.set("page", 1);
                  localStorage.set("pageSize", e.target.value);
                  setPageSize(e.target.value);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={250}>250</MenuItem>
                <MenuItem value={500}>500</MenuItem>
              </TextField>
              <Typography
                sx={{
                  position: "absolute",
                  right: "3%",
                  display: !loading ? "block" : "none",
                }}
              >
                Toplam Kayıt : {totalCount}{" "}
              </Typography>
            </Grid>
            {/* addtax */}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default StatusWaitingPage;
